import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

@Pipe({
  name: 'memberFormControl',
  standalone: true,
  pure: true
})
export class MemberFormControlPipe implements PipeTransform {
  transform(control: AbstractControl | null | undefined, controlName: string): FormControl {
    if (control && (control instanceof FormGroup || control instanceof AbstractControl)) {
      return (control.get(controlName) as FormControl) ?? new FormControl();
    }
    return new FormControl();
  }
}

@Pipe({
  name: 'mainModuleControl',
  standalone: true,
  pure: true
})
export class MainModuleControlPipe implements PipeTransform {
  transform(form: FormGroup, moduleId: string): FormControl {
    if (!form || !moduleId) return new FormControl(false);
    // Must match getMainModuleControl() in drawer-invite-team-member.ts
    const name = `module_main_${moduleId}`;
    let control = form.get(name) as FormControl;
    if (!control) {
      control = new FormControl(false);
      form.addControl(name, control, { emitEvent: false });
    }
    return control;
  }
}

@Pipe({
  name: 'childModuleControl',
  standalone: true,
  pure: true
})
export class ChildModuleControlPipe implements PipeTransform {
  transform(form: FormGroup, moduleId: string, childId: string): FormControl {
    if (!form || !moduleId || !childId) return new FormControl(false);
    const name = `module_${moduleId}_${childId}`;
    let control = form.get(name) as FormControl;
    if (!control) {
      control = new FormControl(false);
      form.addControl(name, control, { emitEvent: false });
    }
    return control;
  }
}

@Pipe({
  name: 'moduleSelectedCount',
  standalone: true,
  pure: true
})
export class ModuleSelectedCountPipe implements PipeTransform {
  transform(module: any, formValue: any, form: FormGroup): number {
    if (!module?.childModules || !form) return 0;
    let count = 0;
    for (const child of module.childModules) {
      const control = form.get(`module_${module.id}_${child.id}`);
      if (control?.value) {
        count++;
      }
    }
    return count;
  }
}

@Pipe({
  name: 'moduleIndeterminate',
  standalone: true,
  pure: true
})
export class ModuleIndeterminatePipe implements PipeTransform {
  transform(module: any, formValue: any, form: FormGroup): boolean {
    if (!module?.childModules || !form) return false;
    let count = 0;
    const total = module.childModules.length;
    for (const child of module.childModules) {
      const control = form.get(`module_${module.id}_${child.id}`);
      if (control?.value) {
        count++;
      }
    }
    return count > 0 && count < total;
  }
}

@Pipe({
  name: 'memberSubtitle',
  standalone: true,
  pure: true
})
export class MemberSubtitlePipe implements PipeTransform {
  transform(member: any, roleValue: any, parkingValue: any): string {
    if (!member) return '';
    const parts: string[] = [];

   // 1. Gender/Role Prefix
    const gender = member.roleGenderValue?.name || member.roleGenderValue;
    if (gender) parts.push(gender);

   // 2. Role
    const role = member.role?.name || roleValue?.name;
    if (role) parts.push(role);

   // 3. Parking
    const parkingVal = member.parking || parkingValue;
    if (parkingVal) {
      if (Array.isArray(parkingVal)) {
        if (parkingVal.length > 0) {
          parts.push(parkingVal.map((p: any) => p.name || p).join(', '));
        }
      } else if (parkingVal.name) {
        parts.push(parkingVal.name);
      }
    }
    return parts.join(' • ');
  }
}
